// dashboard.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
    totalProducts = 0;
    totalCategories = 0;
    totalEnquiries = 0;

    recentActivities: { text: string; time: string; type: string }[] = [];

    constructor(
        private appService: AppService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.loadDashboardData();
    }

    private loadDashboardData(): void {
        this.appService.getDashboardStats().subscribe({
            next: (stats) => {
                if (stats) {
                    this.totalProducts = stats.availableProductCount || 0;
                    this.totalCategories = stats.categoryCount || 0;
                    this.totalEnquiries = stats.openEnquiriesCount || 0;
                }
            },
            error: (err) => console.error('Failed to load dashboard stats', err)
        });
    }

    navigateToAddProduct(): void {
        this.router.navigate(['/admin-products'], { state: { openAddProductModal: true } });
    }

    navigateToAddCategory(): void {
        this.router.navigate(['/admin-categories'], { state: { openAddCategoryModal: true } });
    }

    navigateToAddSpecification(): void {
        this.router.navigate(['/admin-products'], { state: { openAddProductModal: true } });
    }
}
